module.exports = __webpack_public_path__ + "img/uniones-nipples (3).73d7c274.jpg";